// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__wlsnq{
    background: white;
    border-radius: 5px;
    margin: 0 1rem;
    max-height: 83vh;
    padding: 1rem;
}

.styles_status_container__WpYKK {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  
  .styles_aprovada__KZICR {
    background-color: green;
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }
  
  .styles_andamento__UUHzt {
    background-color: rgb(255, 145, 0);
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }
  
  .styles_cancelada__Fm-e3 {
    background-color: rgb(177, 0, 0);
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }
  
  .styles_enviada__Mr8H0 {
    background-color: rgb(28, 42, 235);
    border-radius: 50%;
    height: 0.7rem;
    margin-right: 0.3rem;
    width: 0.7rem;
  }`, "",{"version":3,"sources":["webpack://./src/pages/ProjetosINSS/styles.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf","sourcesContent":[".container{\n    background: white;\n    border-radius: 5px;\n    margin: 0 1rem;\n    max-height: 83vh;\n    padding: 1rem;\n}\n\n.status_container {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .aprovada {\n    background-color: green;\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n  \n  .andamento {\n    background-color: rgb(255, 145, 0);\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n  \n  .cancelada {\n    background-color: rgb(177, 0, 0);\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }\n  \n  .enviada {\n    background-color: rgb(28, 42, 235);\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: 0.3rem;\n    width: 0.7rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__wlsnq`,
	"status_container": `styles_status_container__WpYKK`,
	"aprovada": `styles_aprovada__KZICR`,
	"andamento": `styles_andamento__UUHzt`,
	"cancelada": `styles_cancelada__Fm-e3`,
	"enviada": `styles_enviada__Mr8H0`
};
export default ___CSS_LOADER_EXPORT___;
